<template>
  <div id="app">
    <router-view v-if="isShow"></router-view>
  </div>
</template>
<script>
import { getUpdateTime } from '@/api/login'
import { scrollTop } from 'hooks/index'
export default {
  updated() {
    scrollTop()
  },
  data () {
    return {
      isShow:false
    }
  },
  async created() {
    console.log()
    await this.getTime()
    console.log(187)
  },
  methods: {
    async getTime() {
      await getUpdateTime()
        .then(res => {
          if (res.code == 200 && res.data && res.data.length) {
            let time = res.data[0]
            console.log(time);
            this.$store.dispatch('changeTime', time)
            this.$store.dispatch('changeRealTime', time)
          }
        })
        .catch(err => {
          let date = new Date()
          let day = date.getDate()
          let time
          //mouth 是从 0-11 过次月三号才能显示上一个月数据
          if (date.getMonth() == 0) {
            if (day < 15) {
              time = `${date.getFullYear() - 1}-11`
            } else {
              time = `${date.getFullYear() - 1}-12`
            }
          } else {
            if (day < 15) {
              if (date.getMonth() <= 1) {
                time = `${date.getFullYear() - 1}-${12 - (1 - date.getMonth())}`
              } else {
                time = `${date.getFullYear()}-${date.getMonth() - 1}`
              }
            } else {
              time = `${date.getFullYear()}-${date.getMonth()}`
            }
            this.$store.dispatch('changeTime', time)
          }
          console.log(err)
        }).finally(()=>{
          this.isShow = true
        })
    }
  }
}
</script>
<style>
	/* @import url('./assets/css/reset.less') */
	.anchorBL,
	.amap-logo {
		display: none !important;
	}

	.amap-container {
		background-color: transparent !important;
	}

	.map-center .hotMap {
		visibility: hidden !important;
	}

	.map-center .hotMap.amap-container {
		visibility: visible !important;
	}

	.el-popover.el-popper {
		width: 2.56rem !important;
		padding: 0.04rem 0.16rem 0.13rem 0.16rem;
	}

	/* .el_popover_class {
	} */
	/* 修改el_popover 的箭头 */
	/* .el_popover_class[x-placement^='bottom'] .popper__arrow::after {
		border-bottom-color: #03204e !important;
	}

	.el_popover_class[x-placement^='bottom'] .popper__arrow {
		border-bottom-color: #0368f9 !important;
	} */

	.el-popover__title {
		height: 0.22rem;
		font-size: 0.14rem;
		font-weight: 400;
		color: #003861;
		line-height: 0.22rem;
		margin-bottom: 0.04rem;
	}

	.el_popover_class[x-placement^='top'] .popper__arrow {
		border-top-color: #003861 !important;
	}
</style>
